import styled from 'styled-components'

export const ButtonExportExcelStyle = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  button {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 10px;
    color: ${({ theme }) => {
      return theme.colors.white
    }};
    font-family: inherit;
    font-size: ${({ theme }) => {
      return theme.fonts.size.normal
    }};
    font-weight: ${({ theme }) => {
      return theme.fonts.weight.thin
    }};
    background-color: ${({ theme }) => {
      return theme.colors.success
    }};
    border: none;
    border-radius: ${({ theme }) => {
      return theme.borderRadius.small
    }};
    cursor: pointer;
    transition: background-color 200ms ease-in-out;
    &:hover {
      background-color: ${({ theme }) => {
        return theme.colors.darkSuccess
      }};
    }
    &:disabled {
      background-color: ${({ theme }) => {
        return theme.colors.border
      }};
      cursor: not-allowed;
    }
    img {
      margin: 0 5px 0 0;
      width: 20px;
    }
  }
`
